export enum NatureOfProperty { OldHouse = 1, NewHouse = 2 }
